export default "__VITE_ASSET__BUECyM9m__"